import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const DataTableCard = styled.div`
    color: ${colors.greyscale.darker_grey};
    font-size: 16px;

    .p-datatable .p-column-header-content {
        display: block;
    }

    .p-datatable .p-datatable-thead > tr > th{
        background: white;
        font-size: 14px;
        color: ${colors.greyscale.darker_grey};
        padding: 0.4rem 1rem;
        font-weight: bold;
        outline-width: 5px;
    }

    .p-datatable .p-datatable-thead .pi{
        font-size: 12px;
    }
`